import styled from 'styled-components';

interface BtnProps {
  isSelected?: boolean
}

export const Container = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;

  margin: 0 auto;
  margin-bottom: 15px;
  max-width: 600px;
  padding: 0 5px;

  @media screen and (max-width: 766px) {
    max-width: 550px;
  }
`

export const Content = styled.div`
  background: #FFF;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 6px 12px rgba(61, 69, 67, 0.05);

  width: 100%;
  padding: 30px 25px;
  margin-bottom: 10px;

  strong {
    text-align: center;
    font-size: 18px;
    color: #229890;

    display: flex;
    justify-content: center;
    margin-bottom: 15px;
  }

  > p {
    text-align: start;
    line-height: 20px;
  }

  > div {
    display: flex;
    justify-content: right;
    align-items: center;
    margin-top: 25px;
    text-align: right;

    small {
      margin-right: 12px;
      font-weight: bold;
    }

    a {
      text-decoration: none;
    }
  }

  > small {
    display: flex;
    width: 80%;
    margin: 5px auto 0;
    font-size: 11px;
    font-style: italic;
    text-align: center;
    line-height: 16px;
  }

  @media screen and (max-width: 766px) {
    padding: 20px 15px;

    > small {
      width: 90%;
    }
  }
`

export const UPEContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const UPEBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: 35px;
  padding: 5px 10px;
  margin: 2px 0;

  border: 1px solid #D9DADD;
  border-radius: 4px;

  p {
    width: 150px;
    text-align: left;
  }

  > strong {
    margin: 0;
    justify-content: right;
    position: relative;
    width: 140px;
  }

  > div {
    height: 100%;
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > strong {
      font-size: 14px;
      color: #333333;
      margin: 0;
    }
  }

  @media screen and (max-width: 600px) {
    flex-direction: column;
    align-content: center;

    padding: 5px;
    height: 100%;

    p,
    > strong {
      width: 100%;
      text-align: center;
      justify-content: center;
    }
  }
`

export const ButtonController = styled.button<BtnProps>`
  border-radius: 50%;
  border: none;
  background-color: transparent;
  width: 25px;
  height: 25px;
  margin-top: 3px;

  > svg {
    color: ${props => props.isSelected ? '#229890' : '#D2D2D2'};
  }
`

export const InfoContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  > div {
    display: flex;
    justify-content: space-between;

    width: 100%;
    margin-top: 3px;

    strong {
      font-size: 16px;
      color: ${props => props.theme.colors.mainColor};
    }

    small {
      font-size: 12px;
      display: flex;
    }
  }

  span {
    font-size: 11px;
    color: ${props => props.theme.colors.placeholder};
    font-style: italic;
    margin-top: 15px;
  }

  @media screen and (max-width: 600px) {
    p {
      text-align: left;
    }

    > div {
      margin-top: 8px;

      small {
        text-align: left;
      }
    }
  }
`

export const CheckNoContrib = styled.main`
  width: 100%;
  margin: 15px 0;

  span {
    margin-left: 10px;
  }
`

export const Line = styled.div`
  width: 65%;
  height: 1px;
  margin: 0 auto;
  background-color: ${props => props.theme.colors.backgroundTertiary};
`

export const BtnVoltar = styled.button`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  border: none;
  background-color: unset;
  border-bottom: 1px solid transparent;
  color: ${({ theme }) => theme.colors.text};

  margin-bottom: 15px;

  &:hover {
    border-bottom: 1px solid ${({ theme }) => theme.colors.text};
  }

  &:focus {
    border-bottom: 1px solid ${({ theme }) => theme.colors.text};
  }
`

